import React from 'react';
import TitleBase from './TitleBase';
import { TTitle } from './types';

const Title2 = ({ as = 'h2', ...rest }: TTitle) => <TitleBase {...rest} as={as} kind="title-2" />;

export default Title2;
